import { render, staticRenderFns } from "./QuestionTextAreaWithExplanation.vue?vue&type=template&id=5ef107fc&scoped=true&"
import script from "./QuestionTextAreaWithExplanation.vue?vue&type=script&lang=js&"
export * from "./QuestionTextAreaWithExplanation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef107fc",
  null
  
)

export default component.exports